import PointsOfSaleServices from "@/services/PointOfSale";
import GenericServices from "@/services/Generic";
import WarehousesServices from "@/services/Warehouse";
import helpers from "@/helpers.js";
import CategoriesServices from "@/services/Category";
import warehouseKartelaForm from "./kartela";

export default async function createWarehouse(parent_category = null) {
  var cities = await PointsOfSaleServices.getCities();
  var contact_details = await GenericServices.getDetailsTypes({ related_entity: "warehouse" });
  var main_unit = await WarehousesServices.getWarehouseMainUnits();
  var facility = await WarehousesServices.getWarehouseFacilities();
  var warehouses = await WarehousesServices.getWarehouses();
  var warehouse_categories = helpers.toTree(await CategoriesServices.getCategories("warehouses"), "id");
  var warehouses_selected_categories = {};

  if (parent_category && parent_category.related_entity == "warehouses") {
    warehouses_selected_categories[parent_category.id] = parent_category.name;
  }

  var warehouse_transit = warehouses.filter((ware) => ware.gathering_point == 1);
  warehouse_transit = helpers.toTree(warehouse_transit, "id");

  var users = await PointsOfSaleServices.getUsers();
  var roles = [];
  var priority_order = [];

  roles.unshift({ label: "Primar", id: 1 }, { label: "Sekondar", id: 2 });
  priority_order.unshift({ label: "Rendi Kryesor", id: 1 }, { label: "Rendi 2", id: 2 }, { label: "Rendi 3", id: 3 });

  return warehouseKartelaForm({
    mode: "create",
    wa: null,
    cities,
    contact_details,
    main_unit,
    facility,
    warehouses,
    warehouse_categories,
    warehouses_selected_categories,
    warehouse_transit,
    selected_transit_warehouses: {},
    users,
    roles,
    priority_order,
  });
}
